import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, finalize, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { ActionResult } from 'src/app/models/auth/_models/action-result';
import { MainModel } from 'src/app/models/auth/_models/main-model';
import { Menu } from 'src/app/models/menu';
import { MessagesService } from '../service.index';




@Injectable({
  providedIn: 'root',
})

export class MainHTTPService {
  isLoadingSubject: BehaviorSubject<boolean>;
  private menu: Menu[] = [];
  constructor(private http: HttpClient,private configService: ConfigService,  private _messagesService: MessagesService,) {  this.isLoadingSubject = new BehaviorSubject<boolean>(false);}

  // public methods
  get(code): Observable<ActionResult<MainModel[]>> {
    return this.http.get<ActionResult<MainModel[]>>(`${this.configService.config.apiMainSeven}/main?code=${code}`);
  }

  loadMenu(code: string): Observable<MainModel[]> {
    this.isLoadingSubject.next(true);
    return this.get(code).pipe(
      catchError(err => of(this._messagesService.error("Error conectando con el proveedor de menú"))),
      map((resp: ActionResult<MainModel[]>) => {     
        return resp.result;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }


  getMenu(code): Observable<Menu[]> {
    return this.http
       .get<Menu[]>(`${this.configService.config.apiMainSeven}/main?code=${code}`)
       .pipe(
         tap((_menu) => (this.menu = _menu))
       );
   }


  getFilter(code): Observable<ActionResult<MainModel[]>> {
    return this.http.get<ActionResult<MainModel[]>>(`${this.configService.config.apiMainSeven}/MainFilter?Filter=${code}`);
  }

  updateMainApplicationId(id: string,microApplicationId:any){
    return this.http.get<ActionResult<string>>(`${this.configService.config.apiMainSeven}/GN_MENUS/Update?id=${id}&microApplicationId=${microApplicationId}`)

  }

  getMainMenu(code:any){
    return this.http.get<ActionResult<MainModel>>(`${this.configService.config.apiMainSeven}/main/code?code=${code}`);
  }
  getchores(usu_codi:any,company:string){
    return this.http.get<ActionResult<MainModel>>(`${this.configService.config.apiMainSeven}/main/chores?usu_codi=${usu_codi}&emp_codi=${company}`);
  }

    GetPaymentsByQbe(usu_codi:any,company:string){
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/Imperium/GetPaymentsByQbe?usu_codi=${usu_codi}&emp_codi=${company}`);
  }
}
